"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.optionsWithoutTranslations = void 0;
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _app = require("./app");
/* istanbul ignore next @preserve -- we don't need to test external package functionality. */ var onclose = function onclose() {
    _jsCookie.default.set(_app.SHOULD_BE_CLOSED_COOKIE, 'true');
};
/**
 * Configuration is described here https://github.com/browser-update/browser-update/wiki/Details-on-configuration
 */ var optionsWithoutTranslations = exports.optionsWithoutTranslations = {
    /**
   * This number doesn't say how many versions are supported but how many **older** versions are supported.
   * So as we are generally supporting the 3 latest versions (https://oriflame.visualstudio.com/FrontendPlatform/_wiki/wikis/Front-end/7315/Supported-Browsers),
   * it translates to -2 in this configuration (meaning 1 latest version + 2 older versions).
   *
   * This behavior can be tested here https://browser-update.org/#install.
   *
   * Defaults are defined here https://github.com/browser-update/browser-update/blob/f99dac1461eebf82167e1dddedc58b76fb219097/scripts/update.js#L11C5-L11C107
   *  {c:-3,f:-3,s:-1,e:17,i:11,ios:10,samsung:9.9,o:-3,o_a:-3,y:20.4,v:2.6,uc:13.0,a:535};
   */ required: {
        e: -2,
        f: -2,
        o: -2,
        s: -2,
        ios: -2,
        c: -2,
        i: 0
    },
    reminder: 24,
    reminderClosed: 150,
    l: false,
    test: false,
    /* eslint-disable-next-line @typescript-eslint/naming-convention -- browser-update naming convention */ text_in_xx: '',
    newwindow: true,
    noclose: false,
    nomessage: false,
    jsshowurl: '//browser-update.org/update.show.min.js',
    container: document.body,
    /* eslint-disable-next-line @typescript-eslint/naming-convention -- browser-update naming convention */ no_permanent_hide: true,
    onclose: onclose
}; //# sourceMappingURL=optionsWithoutTranslations.js.map
